module.exports = __webpack_public_path__ + "img/ic_origin.4f669f78.png";